import { StartSpan } from 'modules/Drives/ViewDrive/DriveTimeDrawer/style'
import React from 'react'
export default function Questions({ questions }) {
  return (
    <div>
      <div style={{ padding: '5px', borderTop: '1px solid #E6E7EA' }}></div>
      {questions?.map((item, i) => (
        <>
          <div style={{ paddingTop: '25px' }}>
            {`Q${i + 1}. ${item?.question?.replace(/<[^>]+>|&nbsp;/g, ' ')}`}
            {item?.mandatory && <StartSpan color="red">*</StartSpan>}
          </div>
          {item?.correctAnswerCount && item?.questionType === 'MULTIPLE' && (
            <div
              style={{
                paddingTop: '6px',
                paddingLeft: '2.3em',
                fontSize: '14px',
                color: '#999FAC',
              }}
            >
              {`This question requires ${item?.correctAnswerCount} correct answers`}
            </div>
          )}
          <div>
            <div
              style={{
                display: item.answers?.length > 2 ? '' : 'flex',
                marginTop: '0.5em',
                marginBottom: '2em',
              }}
            >
              {item?.answers?.map((item, index) => {
                const listItem = `${String.fromCharCode(97 + index)}) ${
                  item.answer
                }`
                return (
                  <div
                    style={{
                      display: item.questionType == 'MULTIPLE' ? '' : 'flex',
                      paddingTop: '0.5em',
                      paddingBottom: '0.5em',
                      paddingLeft: '1.6em',
                    }}
                    key={index + item?.questionType}
                  >
                    <div
                      style={{
                        borderRadius: '25px',
                        backgroundColor: item.isCorrect
                          ? '#5DB594'
                          : item.isCorrect === false
                          ? '#E35E50'
                          : '',
                        border: item.isCorrect
                          ? '#5DB594'
                          : item.isCorrect === false
                          ? '#E35E50'
                          : '1px solid #CCCFD6',
                        width: '14px',
                        height: '14px',
                        margin: '4px',
                      }}
                    ></div>{' '}
                    <div
                      style={{
                        marginLeft: '0.5em',
                        marginRight: '4em',
                        color: item.isCorrect
                          ? '#5DB594'
                          : item.isCorrect === false
                          ? '#E35E50'
                          : '',
                      }}
                    >
                      {listItem}
                    </div>
                  </div>
                )
              })}

              <div></div>
            </div>
          </div>
        </>
      ))}
    </div>
  )
}
